/** IP 定位返回的港澳台地区名称（含「中国香港」等写法） */
export const HK_MO_TW_REGIONS = ['香港', '中国香港', '澳门', '中国澳门', '台湾', '中国台湾']

/** 是否为港澳台地区（非内地） */
export function isHongKongMacaoTaiwanRegion(region = '') {
    return HK_MO_TW_REGIONS.includes(region)
}

/** 是否为中国内地 IP（国家为中国且地区非港澳台） */
export function isMainlandChinaIP(country = '', region = '') {
    return country === '中国' && !isHongKongMacaoTaiwanRegion(region)
}
